/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  List,
  MemberRoleOrGuest,
  OrganizationSAMLProvider,
  OrganizationSSOProviderLogin,
  SAMLProviderCertificate,
  SAMLProviderEntityID,
  SAMLProviderLabel,
  URL,
} from "./data-contracts";

/**
 * @description Lists SAML providers configured for the specified organization.
 * @tags sso
 * @name ListSamlProvidersInOrganizationById
 * @summary List all SAML providers
 * @request GET:/orgs/{organizationId}/saml
 * @secure
 */

// @ts-ignore
export const listSAMLProvidersInOrganizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OrganizationSAMLProvider[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/saml",
  method: "get",
  streaming: false,
  tags: ["sso"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sso
 * @name CreateOrganizationSamlProvider
 * @summary Create a new SAML provider
 * @request POST:/orgs/{organizationId}/saml
 * @secure
 */

// @ts-ignore
export const createOrganizationSAMLProvider: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    label: SAMLProviderLabel;
    entityID?: SAMLProviderEntityID;
    certificate?: SAMLProviderCertificate;
    ssoURL?: URL;
    defaultTeam?: string;
    /** The role of a member in an organization, null for guests */
    defaultRole?: MemberRoleOrGuest;
  };
  RequestHeaders: {};
  ResponseBody: OrganizationSAMLProvider;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/saml",
  method: "post",
  streaming: false,
  tags: ["sso"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sso
 * @name GetOrganizationSamlProviderById
 * @summary Get a SAML provider by its ID
 * @request GET:/orgs/{organizationId}/saml/{samlProviderId}
 * @secure
 */

// @ts-ignore
export const getOrganizationSAMLProviderById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the SAML provider */
    samlProviderId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationSAMLProvider;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/saml/{samlProviderId}",
  method: "get",
  streaming: false,
  tags: ["sso"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sso
 * @name UpdateOrganizationSamlProvider
 * @summary Update a SAML provider
 * @request PATCH:/orgs/{organizationId}/saml/{samlProviderId}
 * @secure
 */

// @ts-ignore
export const updateOrganizationSAMLProvider: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the SAML provider */
    samlProviderId: string;
  };
  RequestQuery: {};
  RequestBody: {
    label?: SAMLProviderLabel;
    entityID?: SAMLProviderEntityID;
    certificate?: SAMLProviderCertificate;
    ssoURL?: URL;
    defaultTeam?: string;
    /** The role of a member in an organization, null for guests */
    defaultRole?: MemberRoleOrGuest;
  };
  RequestHeaders: {};
  ResponseBody: OrganizationSAMLProvider;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/saml/{samlProviderId}",
  method: "patch",
  streaming: false,
  tags: ["sso"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sso
 * @name DeleteOrganizationSamlProvider
 * @summary Delete a SAML provider
 * @request DELETE:/orgs/{organizationId}/saml/{samlProviderId}
 * @secure
 */

// @ts-ignore
export const deleteOrganizationSAMLProvider: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the SAML provider */
    samlProviderId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/saml/{samlProviderId}",
  method: "delete",
  streaming: false,
  tags: ["sso"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sso
 * @name ListSsoProviderLoginsInOrganization
 * @summary List all SSO provider login infos
 * @request GET:/orgs/{organizationId}/sso
 * @secure
 */

// @ts-ignore
export const listSSOProviderLoginsInOrganization: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    items: OrganizationSSOProviderLogin[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sso",
  method: "get",
  streaming: false,
  tags: ["sso"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
